import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import { TernaryNodeModel } from "./TernaryNodeModel";
import { TernaryNodeWidget } from './TernaryNodeWidget';
export class TernaryNodeFactory extends AbstractReactFactory {
  constructor() {
    super('ternary');
  }

  generateReactWidget(event) {
    return /*#__PURE__*/React.createElement(TernaryNodeWidget, {
      engine: this.engine,
      size: 50,
      model: event.model
    });
  }

  generateModel(event) {
    return new TernaryNodeModel();
  }

}